// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"25c09542","432":"18e3a841","517":"18e3a841","520":"25c09542"}[chunkId] + ".chunk.css";
};